import React from 'react'
import PropTypes from 'prop-types'

import MetaDataHelmet from '../../../Shared/MetaDataHelmet'
import PartnersTierContainer from './PartnersTierContainer'

function PartnersPage({ competitionSlug }) {
  const metaTitle = I18n.t(`competition.${competitionSlug}.meta.title.partners`)
  const metaDescription = I18n.t(`competition.${competitionSlug}.meta.description.partners`)
  const pageDescription = I18n.t(`competition.${competitionSlug}.partners.page_description`)

  const partnersByTier = ((partnerTier) => {
    return I18n.t(`competition.${competitionSlug}.partners.${partnerTier}`)
  })

  return (
    <div className="competition-partners-page">
      <MetaDataHelmet title={metaTitle} description={metaDescription} />

      <section className="content-section section--partners">
        <div className="container-fixed">
          <h2 className="content-section__title">Partners</h2>
          <p className="content-section__subtitle">{pageDescription}</p>

          <PartnersTierContainer partners={partnersByTier('diamond_tier')} partnersTier="Diamond" />
          <PartnersTierContainer partners={partnersByTier('gold_tier')} partnersTier="Gold" />
          <PartnersTierContainer partners={partnersByTier('silver_tier')} partnersTier="Silver" />
          <PartnersTierContainer partners={partnersByTier('bronze_tier')} partnersTier="Bronze" />
          <PartnersTierContainer partners={partnersByTier('media')} partnersTier="Media" />
        </div>
      </section>
    </div>
  )
}

PartnersPage.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default PartnersPage
